import React, { useEffect, useRef, useState } from "react";
import DwgNavigator from "./DwgNavigator";

export default function DwgFinderViewer()
{
    const viewportRef =
            useRef(null);

    const [viewerData, setViewerData] =
            useState(null);

    const [selectedEntity, setSelectedEntity] =
            useState(null);


    //
    // Display scale.
    //
    // Our SVG coordinate system remains the original
    // PDF coordinate system.
    //
    // This simply controls how large the drawing is
    // displayed inside the scrollable viewport.
    //

    const drawingScale =
            2.0;


    //
    // Load Finder data.
    //

    useEffect(() =>
    {
        let cancelled =
                false;


        async function loadFinderData()
        {
            try
            {
                const response =
                        await fetch(
                            "/resolutionsoftwareplatform/gettestdwgfinder",
                            {
                                method: "GET",
                                cache: "no-store"
                            });


                if(!response.ok)
                {
                    console.error(
                        "Unable to get Finder drawing data");

                    return;
                }


                const data =
                        await response.json();


                if(cancelled)
                {
                    return;
                }


                console.log(
                    "Finder drawing data:",
                    data);


                setViewerData(
                        data);
            }
            catch(error)
            {
                console.error(
                    "Error loading Finder drawing:",
                    error);
            }
        }


        loadFinderData();


        return () =>
        {
            cancelled =
                    true;
        };

    }, []);


    //
    // Select / deselect entity.
    //

    function selectEntity(entity)
    {
        if(entity == null)
        {
            return;
        }


        //
        // Second click deselects.
        //

        if(selectedEntity != null &&
           selectedEntity.name === entity.name)
        {
            setSelectedEntity(
                null);


            //
            // Return roughly to the top-left for now.
            //
            // We can replace this with proper fit-to-view
            // when we add zoom/pan.
            //

            if(viewportRef.current != null)
            {
                viewportRef.current.scrollTo({
                    left: 0,
                    top: 0,
                    behavior: "smooth"
                });
            }


            return;
        }


        setSelectedEntity(
            entity);


        //
        // Scroll selected entity into the centre
        // of our viewport.
        //

        if(viewportRef.current != null)
        {
            const viewport =
                    viewportRef.current;


            const scaledX =
                    entity.x *
                    drawingScale;


            const scaledY =
                    entity.y *
                    drawingScale;


            const targetLeft =
                    scaledX -
                    (viewport.clientWidth / 2);


            const targetTop =
                    scaledY -
                    (viewport.clientHeight / 2);


            viewport.scrollTo({
                left: Math.max(
                    0,
                    targetLeft),

                top: Math.max(
                    0,
                    targetTop),

                behavior: "smooth"
            });
        }
    }


    //
    // Styles
    //

   


    //
    // Loading.
    //

    if(viewerData == null ||
       viewerData.image == null)
    {
        return (
            <div
                style={{
                    width: "100%",
                    height: "100%",

                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",

                    background: "#f5f6f8",

                    color: "#666666",
                    fontSize: "13px"
                }}
            >
                Loading Finder drawing...
            </div>
        );
    }


    //
    // Render.
    //

    const drawingWidth =
            viewerData.width *
            drawingScale;


    const drawingHeight =
            viewerData.height *
            drawingScale;


    return (
        <div
            style={{
                position: "relative",
                width: "100%",
                height: "100%",
                background: "#e9ebee",
                overflow: "hidden"
            }}
        >

            {/* SCROLLABLE DRAWING VIEWPORT */}

            <div
                ref={viewportRef}

                style={{
                    position: "absolute",

                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,

                    overflow: "auto",

                    padding: "40px",

                    boxSizing: "border-box"
                }}
            >

                {/* DRAWING SURFACE */}

                <div
                    style={{
                        position: "relative",

                        width:
                            drawingWidth + "px",

                        height:
                            drawingHeight + "px",

                        background: "white",

                        boxShadow:
                            "0 8px 32px rgba(0,0,0,0.18)"
                    }}
                >

                    {/* PDF RENDERED AS PNG */}

                    <img
                        src={viewerData.image}

                        alt={viewerData.drawingName}

                        draggable={false}

                        style={{
                            position: "absolute",

                            left: 0,
                            top: 0,

                            width: "100%",
                            height: "100%",

                            display: "block",

                            userSelect: "none",

                            pointerEvents: "none"
                        }}
                    />


                    {/* OMNISCAN SEMANTIC OVERLAY */}

                    <svg
                        viewBox={
                            "0 0 " +
                            viewerData.width +
                            " " +
                            viewerData.height
                        }

                        preserveAspectRatio="none"

                        style={{
                            position: "absolute",

                            left: 0,
                            top: 0,

                            width: "100%",
                            height: "100%",

                            overflow: "visible"
                        }}
                    >

                        {viewerData.entities &&
                         viewerData.entities.map(
                            (entity, index) =>
                            {
                                const selected =
                                        selectedEntity != null &&
                                        selectedEntity.name ===
                                            entity.name;


                                //
                                // Our actual text bounds are tiny.
                                //
                                // Create a deliberately larger
                                // OmniScan hotspot around the
                                // text centre.
                                //

                                const hotspotWidth =
                                        10;


                                const hotspotHeight =
                                        6;


                                const centreX =
                                        entity.x +
                                        (entity.width / 2);


                                const centreY =
                                        entity.y +
                                        (entity.height / 2);


                                const hotspotX =
                                        centreX -
                                        (hotspotWidth / 2);


                                const hotspotY =
                                        centreY -
                                        (hotspotHeight / 2);


                                return (
                                    <g
                                        key={
                                            entity.name +
                                            "-" +
                                            index
                                        }

                                        onClick={() =>
                                            selectEntity(
                                                entity)
                                        }

                                        style={{
                                            cursor: "pointer"
                                        }}
                                    >

                                        <rect
                                            x={hotspotX}
                                            y={hotspotY}

                                            width={hotspotWidth}
                                            height={hotspotHeight}

                                            rx="0.8"

                                            fill={
                                                selected
                                                    ? "rgba(0,110,255,0.28)"
                                                    : "rgba(0,110,255,0.08)"
                                            }

                                            stroke={
                                                selected
                                                    ? "#0076ff"
                                                    : "rgba(0,110,255,0.55)"
                                            }

                                            strokeWidth={
                                                selected
                                                    ? "0.8"
                                                    : "0.35"
                                            }

                                            vectorEffect="non-scaling-stroke"
                                        />

                                    </g>
                                );
                            })
                        }

                    </svg>

                </div>

            </div>


            {/* DRAWING NAVIGATOR */}

			{/* DRAWING NAVIGATOR */}

			<DwgNavigator
			    entities={
			        viewerData.entities ||
			        []
			    }

			    selectedEntity={
			        selectedEntity
			    }

			    selectEntity={
			        selectEntity
			    }

			    category="DESKS"
			/>

            

        </div>
    );
}